<!--
<h2 mat-dialog-title style="text-align: center">Annahmeprotokoll ausfüllen</h2>
-->
<div
  mat-dialog-title
  #title
  style="display: flex; justify-content: stretch; width: 100%; margin-top: 0.5rem"
>
  <div style="flex: 1; margin-right: 0.5rem; text-align: center">
    Annahmeprotokoll ausfüllen
  </div>
  <div>
    <app-document-paginator
      [data]="documentInfo"
      [page]="currentPageIdx"
      (pagechanged)="loadPage($event)"
    >
    </app-document-paginator>
  </div>
</div>
<mat-dialog-content #cnt class="mat-typography" style="max-height: 85%">
  <div style="position: relative; top: 0; left: 0; padding-bottom: 1rem">
    <div *ngIf="isLoading" class="document-progress-bar-placeholder"></div>
    <div *ngIf="isLoading" class="document-progress-bar-wrapper">
      <app-document-progress-bar></app-document-progress-bar>
    </div>

    <ng-container *ngIf="!isLoading">
      <img #docImg *ngIf="!imgUrl" class="img-pdf-content" />
      <img [src]="imgUrl" *ngIf="imgUrl" class="img-pdf-content" />

      <ng-container *ngIf="currentPageIdx === 1">
        <!--Schaden -->
        <app-image-edit
          #canvasDamage
          [block-style]="damageStyle"
          [canvas-style]="damageCanvasStyle"
          [canvas-options]="damageCanvasOptions"
          [data]="lastDamageData"
          name="damage"
          (clear)="clear($event)"
        >
        </app-image-edit>

        <app-text-area-edit
          #damageNote
          [block-style]="damageNoteStyle"
          [canvas-options]="damageTextOptions"
          [canvas-style]="damageNoteCanvasStyle"
          [clear-btn-style]="damageNoteClearStyle"
          [comment-type]="lastDamageRes?.type || 1"
          [free-text]="lastDamageRes?.free_text || ''"
          [text]="lastDamageRes?.text || ''"
          [rows]="7"
          [cols]="60"
          [maxlength]="400"
          name="damage_note"
          [switch-style]="damageNoteSwitchStyle"
          (clear)="clear($event)"
        >
        </app-text-area-edit>
        <!--
        <div class="bg-transparent pos-absolute" [style]="damageNoteStyle">
          <textarea
            class="bg-transparent"
            *ngIf="commentType === 1"
            rows="7"
            cols="60"
            maxlength="580"
            style="resize: none; font-size: 0.6cm; line-height: 1.06cm"
            [ngStyle]="damageNoteCanvasStyle"
            #damageNoteText
          >
          </textarea>
          <canvas
            *ngIf="commentType === 2"
            #damageNote
            style="border: 2px dashed grey"
            [ngStyle]="damageNoteCanvasStyle"
          ></canvas>
          <div></div>
        </div>
        <div
          *ngIf="commentType === 2"
          class="pos-absolute"
          [style]="damageNoteClearStyle"
        >
          <button (click)="clear('damage_note')">Leeren</button>
        </div>

        <div
          class="bg-transparent pos-absolute"
          [style]="damageNoteSwitchStyle"
        >
          <div
            style="padding: 4px"
            [ngClass]="{ 'green-round-icon-border': commentType === 1 }"
          >
            <button mat-icon-button (click)="changeCommentType(1)">
              <mat-icon style="width: 1cm; height: 1cm">keyboard</mat-icon>
            </button>
          </div>

          <div style="width: 0.5cm; height: 0.5cm"></div>
          <div
            style="padding: 0.1cm"
            [ngClass]="{ 'green-round-icon-border': commentType === 2 }"
          >
            <button mat-icon-button (click)="changeCommentType(2)">
              <mat-icon style="width: 1cm; height: 1cm">edit</mat-icon>
            </button>
          </div>
        </div>
      -->
      </ng-container>

      <ng-container *ngIf="currentPageIdx === 2">
        <!--Kunde (Unterschrift) -->
        <app-image-edit
          #signCanvasCustomer
          [block-style]="signCustomerStyle"
          [canvas-style]="signCustomerCanvasStyle"
          [clear-btn-style]="'fill-acceptance-clear-signature-button'"
          [data]="lastCustomerSignature"
          name="customer_sign"
          (clear)="clear($event)"
        >
        </app-image-edit>

        <!--Montageleiter (Unterschrift)-->
        <app-image-edit
          #signCanvas
          [block-style]="signMontageStyle"
          [canvas-style]="signMontageCanvasStyle"
          [clear-btn-style]="'fill-acceptance-clear-signature-button'"
          [data]="lastWorkerSignature"
          name="montage_sign"
          (clear)="clear($event)"
        >
        </app-image-edit>
      </ng-container>
    </ng-container>
  </div>
</mat-dialog-content>
<div
  mat-dialog-actions
  class="row-layout flex-content-space-between pdf-dialog-actions"
>
  <!--style="border-right: 1px solid grey"-->
  <div>
    <button
      [disabled]="!dataLoaded"
      mat-button
      class="document-select"
      (click)="loadPage(0)"
    >
      Kunde
    </button>
    <button
      [disabled]="!dataLoaded"
      mat-button
      class="document-select"
      (click)="loadPage(1)"
    >
      Schaden
    </button>
    <button
      [disabled]="!dataLoaded"
      mat-button
      class="document-select"
      (click)="loadPage(2)"
    >
      Unterschrift
    </button>
  </div>
  <div>
    <button mat-button class="document-cancel" (click)="signClose(false)">
      Abbrechen
    </button>
    <button mat-button class="document-save" (click)="signClose(true)">
      Speichern
    </button>
  </div>
</div>
